import { IndicatorClass } from "../data/indicator-class"

const selectInfoLink = (
  indicatorClass: IndicatorClass,
  geoVariable: string
) => {
  let linkStart = ""
  let linkEnd: string | undefined = ""
  if (indicatorClass === "GEM-GLO") {
    linkStart =
      "gem-glo-content-and-references-gem-ghg-emissions-monitoring-domain-global"
    linkEnd = getGemGloVar(geoVariable)
  } else if (indicatorClass === "GEM-EUR") {
    linkStart =
      "gem-eur-content-and-references-gem-ghg-emissions-monitoring-domain-europe"
    linkEnd = getGemEurVar(geoVariable)
  } else if (indicatorClass === "CWM-GLO") {
    linkStart =
      "cwm-glo-content-and-references-cwm-climate-warming-monitoring-domain-global"
    linkEnd = getGwmGloVar(geoVariable)
  } else if (indicatorClass === "GEM-AT") {
    linkStart =
      "gem-at-content-and-references-gem-ghg-emissions-monitoring-domain-austria"
    linkEnd = getGemAtVar(geoVariable)
  } else if (indicatorClass === "EWM-AT" || indicatorClass === "EWM-EUR") {
    linkStart =
      "ewm-at-content-and-references-ewm-extreme-weather-monitoring-domain-austria"
    linkEnd = getEwmAtVar(geoVariable)
  }
  return { linkStart, linkEnd }
}

const getGemGloVar = (variable: string) => {
  let lnk = ""
  switch (variable) {
    case "GCCIv2/GEM_GLO/GCCI-GEM_GLO_IV_GCCIClimActionPerfIndex_Annual_Percent_public.json":
      lnk = "v1.-gcci-climate-action-performance-index"
      break
    case "GCCIv2/GEM_GLO/GCCI-GEM_GLO_IV_CO2EmsChangeIndex_Annual_Percent_public.json":
      lnk = "v2.-co2-emissions-change-index"
      break
    case "GCCIv2/GEM_GLO/GCCI-GEM_GLO_IV_GHGEmsChangeIndex_Annual_Percent_public.json":
      lnk = "v3.-ghg-emissions-change-index"
      break
    case "GCCIv2/GEM_GLO/GCCI-GEM_GLO_PV_CO2Emissions_Annual_MtCO2_public.json":
      lnk = "v4.-co2-annual-emissions-mtco2"
      break
    case "GCCIv2/GEM_GLO/GCCI-GEM_GLO_PV_GHGEmissions_Annual_MtCO2eq_public.json":
      lnk = "v5.-ghg-annual-emissions-mtco2eq"
      break
    case "GCCIv2/GEM_GLO/GCCI-GEM_GLO_DV_CO2EmissionspPers_Annual_tCO2pPers_public.json":
      lnk = "v6.-co2-annual-emissions-per-person-tco2-person"
      break
    case "GCCIv2/GEM_GLO/GCCI-GEM_GLO_DV_GHGEmissionspPers_Annual_tCO2eqpPers_public.json":
      lnk = "v7.-ghg-annual-emissions-per-person-tco2eq-person"
      break
    case "GCCIv2/GEM_GLO/GCCI-GEM_GLO_DV_CO2EmissionspEcon_Annual_tCO2pMEuro_public.json":
      lnk = "v8.-co2-emissions-per-gdp-and-ppp-tonnes-of-co2-per-million-eur"
      break
    case "GCCIv2/GEM_GLO/GCCI-GEM_GLO_DV_GHGEmissionspEcon_Annual_tCO2eqpMEuro_public.json":
      lnk = "v9.-ghg-emissions-per-gdp-and-ppp-tonnes-of-co2-per-million-eur"
      break
    case "GCCIv2/GEM_GLO/GCCI-GEM_GLO_SV_Population_Annual_Mio.Persons_public.json":
      lnk = "v10.-population-size-mio.-of-persons"
      break
    case "GCCIv2/GEM_GLO/GCCI-GEM_GLO_SV_EconomicData_Annual_EUR_public.json":
      lnk = "v11.-economic-data-billions-of-eur"
      break
    case "GCCIv2/GEM_GLO/GCCI-GEM_GLO_DV_EconomicDatapPers_Annual_EURpPers_public.json":
      lnk = "v12.-economic-data-per-person-eur-per-person"
      break
  }
  return lnk
}

const getGemEurVar = (variable: string) => {
  switch (variable) {
    case "GCCIv2/GEM_EUR/GCCI-GEM_EUR_IV_GCCIClimActionPerfIndex_Annual_Percent_public.json":
      return "v1.-gcci-climate-action-performance-index"
    case "GCCIv2/GEM_EUR/GCCI-GEM_EUR_IV_CO2EmsChangeIndex_Annual_Percent_public.json":
      return "v2.-co2-emissions-change-index"
    case "GCCIv2/GEM_EUR/GCCI-GEM_EUR_IV_GHGEmsChangeIndex_Annual_Percent_public.json":
      return "v3.-ghg-emissions-change-index"
    case "GCCIv2/GEM_EUR/GCCI-GEM_EUR_PV_CO2Emissions_Annual_MtCO2_public.json":
      return "v4.-co2-annual-emissions-mtco2"
    case "GCCIv2/GEM_EUR/GCCI-GEM_EUR_PV_GHGEmissions_Annual_MtCO2eq_public.json":
      return "v5.-ghg-annual-emissions-mtco2eq"
    case "GCCIv2/GEM_EUR/GCCI-GEM_EUR_DV_CO2EmissionspPers_Annual_tCO2pPers_public.json":
      return "v6.-co2-annual-emissions-per-person-tco2-person"
    case "GCCIv2/GEM_EUR/GCCI-GEM_EUR_DV_GHGEmissionspPers_Annual_tCO2eqpPers_public.json":
      return "v7.-ghg-annual-emissions-per-person-tco2eq-person"
    case "GCCIv2/GEM_EUR/GCCI-GEM_EUR_DV_CO2EmissionspEcon_Annual_tCO2pMEuro_public.json":
      return "v8.-co2-emissions-per-gdp-and-ppp-tonnes-of-co2-per-million-eur"
    case "GCCIv2/GEM_EUR/GCCI-GEM_EUR_DV_GHGEmissionspEcon_Annual_tCO2eqpMEuro_public.json":
      return "v9.-ghg-emissions-per-gdp-and-ppp-tonnes-of-co2-per-million-eur"
    case "GCCIv2/GEM_EUR/GCCI-GEM_EUR_SV_Population_Annual_Mio.Persons_public.json":
      return "v10.-population-size-mio.-of-persons"
    case "GCCIv2/GEM_EUR/GCCI-GEM_EUR_SV_EconomicData_Annual_EUR_public.json":
      return "v11.-economic-data-billions-of-eur"
    case "GCCIv2/GEM_EUR/GCCI-GEM_EUR_DV_EconomicDatapPers_Annual_EURpPers_public.json":
      return "v12.-economic-data-per-person-eur-per-person"
  }
}

const getGemAtVar = (variable: string) => {
  switch (variable) {
    case "GCCIv2/GEM_AUT/GCCI-GEM_AUT_IV_GCCIClimActionPerfIndex_Annual_Percent_public.json":
      return "v1.-gcci-climate-action-performance-index"
    case "GCCIv2/GEM_AUT/GCCI-GEM_AUT_IV_CO2EmsChangeIndex_Annual_Percent_public.json":
      return "v2.-co2-emissions-change-index"
    case "GCCIv2/GEM_AUT/GCCI-GEM_AUT_IV_GHGEmsChangeIndex_Annual_Percent_public.json":
      return "v3.-ghg-emissions-change-index"
    case "GCCIv2/GEM_AUT/GCCI-GEM_AUT_PV_CO2Emissions_Annual_MtCO2_public.json":
      return "v4.-co2-annual-emissions-mtco2"
    case "GCCIv2/GEM_AUT/GCCI-GEM_AUT_PV_GHGEmissions_Annual_MtCO2eq_public.json":
      return "v5.-ghg-annual-emissions-mtco2eq"
    case "GCCIv2/GEM_AUT/GCCI-GEM_AUT_DV_CO2EmissionspPers_Annual_tCO2pPers_public.json":
      return "v6.-co2-annual-emissions-per-person-tco2-person"
    case "GCCIv2/GEM_AUT/GCCI-GEM_AUT_DV_GHGEmissionspPers_Annual_tCO2eqpPers_public.json":
      return "v7.-ghg-annual-emissions-per-person-tco2eq-person"
    case "GCCIv2/GEM_AUT/GCCI-GEM_AUT_DV_CO2EmissionspEcon_Annual_tCO2pMEuro_public.json":
      return "v8.-co2-emissions-per-gdp-and-ppp-tonnes-of-co2-per-million-eur"
    case "GCCIv2/GEM_AUT/GCCI-GEM_AUT_DV_GHGEmissionspEcon_Annual_tCO2eqpMEuro_public.json":
      return "v9.-ghg-emissions-per-gdp-and-ppp-tonnes-of-co2-per-million-eur"
    case "GCCIv2/GEM_AUT/GCCI-GEM_AUT_SV_Population_Annual_Mio.Persons_public.json":
      return "v10.-population-size-mio.-of-persons"
    case "GCCIv2/GEM_AUT/GCCI-GEM_AUT_SV_EconomicData_Annual_EUR_public.json":
      return "v11.-economic-data-billions-of-eur"
    case "GCCIv2/GEM_AUT/GCCI-GEM_AUT_DV_EconomicDatapPers_Annual_EURpPers_public.json":
      return "v12.-economic-data-per-person-eur-per-person"
  }
}

const getEwmAtVar = (variable: string) => {
  switch (variable) {
    case "GCCIv3/EWM_AUT/GCCI-EWM_AUT_PV_HeatExtrEventFrequency_Annual_pYr_public.json":
      return "v1.-heat-extremes-1"
    case "GCCIv1/EWM_AUT/GCCI-EWM_AUT_PV_HeatExtremes_Annual_1_public.json":
      return "v1.-heat-extremes-1"
    case "GCCIv1/EWM_AUT/GCCI-EWM_AUT_PV_PrecipExtremes_Annual_1_public.json":
      return "v2.-precipitation-extremes-1"
  }
}

const getGwmGloVar = (variable: string) => {
  switch (variable) {
    case "GCCIv2/CWM_GLO/GCCI-CWM_GLO_IV_GCCIGlobWarmingAmplIndex_Annual_Percent_public.json":
      return "v1.-gcci-global-warming-amplification-index"
    case "GCCIv2/CWM_GLO/GCCI-CWM_GLO_PV_AHCIncrease_Annual_ZJperDecade_public.json":
      return "v2.-atmospheric-heat-content-ahc-increase-zj-decade"
    case "GCCIv2/CWM_GLO/GCCI-CWM_GLO_PV_EEU_Annual_ZJ_public.json":
      return "v3.-earth-energy-uptake-since-1960-zj"
    case "GCCIv2/CWM_GLO/GCCI-CWM_GLO_PV_EEI_Annual_ZJperYear_public.json":
      return "v4.-earth-energy-imbalance-eei-zj-year"
    case "GCCIv2/CWM_GLO/GCCI-CWM_GLO_DV_EEI_per_m2_Annual_Wm-2_public.json":
      return "v5.-earth-energy-imbalance-eei-per-m2-w-m"
    case "GCCIv2/CWM_GLO/GCCI-CWM_GLO_PV_GHGConcentrations_Annual_ppm_public.json":
      return "v6.-ghg-annual-concentrations-ppm"
    case "GCCIv2/CWM_GLO/GCCI-CWM_GLO_PV_ERF_Annual_ZJperYear_public.json":
      return "v7.-effective-radiative-forcing-zj-year"
    case "GCCIv2/CWM_GLO/GCCI-CWM_GLO_DV_ERF_per_m2_Annual_Wm-2_public.json":
      return "v8.-effective-radiative-forcing-per-m2-w-m"
    case "GCCIv2/CWM_GLO/GCCI-CWM_GLO_PV_GlobalSurfaceTempChange_Annual_degC_public.json":
      return "v9.-global-surface-temperature-change-c"
    case "GCCIv2/CWM_GLO/GCCI-CWM_GLO_DV_ForcingResponseImbalance_Annual_Wm-2_public.json":
      return "v10.-forcing-response-imbalance-estimates-w-m"
    case "GCCIv2/CWM_GLO/GCCI-CWM_GLO_PV_GlobalSurfTempTrendRate_Annual_degCperDecade_public.json":
      return "v11.-global-surface-temperature-trend-rate-c-decade"
  }
}

export default selectInfoLink
